<template>
<nav class="navbar navbar-expand-lg navbar" style="background-color: rgba(225, 227, 231, 1)!important;">
  <a class="navbar-brand" href="#">
    <img src="img/icons/nettowin.png" style="height: 50px; margin-left: 20px" alt="NetToWin AG">
  </a>
  <div id="idMainNavbar" class="container-fluid">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" 
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a ref="Home" @click.prevent="action('Home')" class="nav-link menu__text" aria-current="page" >Home</a>
        </li>
        <li v-if="IsInFunctionalRoles('MasterAdmin,DokumentenverwaltungProfessional')" class="nav-item">
          <a ref = "Dokument" @click.prevent="action('DocumentManagement')" class="nav-link  menu__text" aria-current="page" >Dokumentenverwaltung</a>
        </li>
        <li v-if="IsInFunctionalRoles('MasterAdmin,Kundendienst')" class="nav-item">
          <a ref="Auftrag" @click.prevent="action('AuftragsErfassung')" class="nav-link  menu__text" aria-current="page" >Kundendienst</a>
        </li>
        <li v-if="IsInFunctionalRoles('MasterAdmin,MenuMasterBerichte')" class="nav-item">
          <a ref="Bericht" @click.prevent="action('Berichte')" class="nav-link  menu__text" aria-current="page" >Berichte</a>
        </li>        
        <li  v-if="IsInFunctionalRoles('MasterAdmin,MonitoringEasy,OnlineCheckEasy,MonitoringProfessional,OnlineCheckProfessional')"  class="nav-item">
          <a ref="ControlCenter" @click.prevent="action('ControlCenter')" class="nav-link menu__color--adjust menu__text" tabindex="-1" aria-disabled="false">Monitoring</a>
        </li>
        <li  v-if="IsInFunctionalRoles('MasterAdmin,MenuStammdaten,RegisterStammdatenGeraet,RegisterStammdatenPerson')"  class="nav-item">
          <a ref="Stammdaten" @click.prevent="action('Stammdaten')" class="nav-link menu__color--adjust menu__text" tabindex="-1" aria-disabled="false">Kundendaten</a>
        </li>
        <li  v-if="IsInFunctionalRoles('MasterAdmin')"  class="nav-item">
          <a ref ="Benutzerdaten" @click.prevent="action('Benutzerdaten')" class="nav-link menu__color--adjust menu__text" tabindex="-1" aria-disabled="false">Benutzerdaten</a>
        </li>

        <li  v-if="IsInFunctionalRoles('MasterAdmin')" class="nav-item">
          <a ref="RefreshReport" @click.prevent="action('RefreshReport')" class="nav-link nav-link  menu__text" tabindex="-1" aria-disabled="false">Berechnen</a>
        </li>
        <li  v-if="IsInFunctionalRoles('MasterAdmin')" class="nav-item">
          <a ref ="Report"  @click.prevent="action('Report')" class="nav-link nav-link  menu__text" tabindex="-1" aria-disabled="false">Rechnungen</a>
        </li>

        <li  class="nav-item">
          <a ref ="Profil"  @click.prevent="action('ChangePassword')" class="nav-link nav-link  menu__text" tabindex="-1" aria-disabled="false">Kennwort ändern</a>
        </li>


        <li v-if="isRefreshVisible" @click.prevent="onSelect('refresh')" class="nav-item" style="margin-left: 50px">             
            <p @click.prevent="onSelect('refresh')" style="display: inline-block; margin-right: 5px; margin-top:10px; font-size: 0.75rem; text-align: center;"> 
              <SvgIcon :icon="arrowRotateCcwIcon" :size="'small'" class="icon__button-icon" />
            </p>             
            <a ref = "refresh"  class="nav-link menu__text" style="display: inline-block;" aria-current="page" >Aktualisieren</a>    
        </li>


      </ul>
    </div>
    <p style="display: inline-block; margin-right: 10px; margin-top:10px; font-size: 0.75rem; text-align: center;">Angemeldet: 
    </p>

    <p style="display: inline-block; margin-right: 20px; margin-top:10px; font-size: 0.75rem; font-weight:bold; text-align: center;">{{benutzerName}} 
    </p>
    <p @click.prevent="action('Logout')" style="display: inline-block; margin-right: 20px; margin-top:10px; font-size: 0.75rem; text-align: center;"> 
      <SvgIcon :icon="logoutIcon" :size="'medium'" class="icon__button-icon"/>
    </p>
  </div>
</nav>

<KennwortAendern v-if="isPasswordEditVisible" v-bind="kennwortData" @password-changed="onPasswordChanged"/> 


</template>

<script lang="ts">
import { GridEventService } from '@/infrastructure/observables/gridEventState';
import router from '@/router';
import { defineComponent, onUnmounted, reactive, ref } from 'vue';
import { NavigationFailureType, isNavigationFailure } from 'vue-router'
import { SvgIcon } from '@progress/kendo-vue-common';
import { UserProfile } from "@/infrastructure/backend/userProfile";
import { LogoutStateServiceForRoot } from '@/infrastructure/observables/logoutState';
import { arrowRotateCcwIcon, pencilIcon,trashIcon,plusIcon,uploadIcon,logoutIcon,eyeIcon,envelopeIcon,fileHeaderIcon,tellAFriendIcon, homeIcon } from '@progress/kendo-svg-icons';
import { RefreshGridServiceForRoot } from '@/infrastructure/observables/refreshGridState';
import { StammdatenReceiverServiceForRoot } from '@/infrastructure/observables/stammDatenReceiver';
import KennwortAendern from '../benutzerdaten/sideeffects/KennwortAendern.vue';
import { Identity } from '@/infrastructure/backend/userIdentity';

    export default defineComponent ({
        components: {
          SvgIcon,
          KennwortAendern
        },
        name: "MenuBar",
        inheritAttrs: false,  
        setup() {
            

          const Home:any = ref(null);
          const Dokument:any = ref(null);
          const Auftrag:any = ref(null);
          const Bericht:any = ref(null);
          const ControlCenter:any = ref(null);
          const Stammdaten:any = ref(null);
          const Benutzerdaten:any = ref(null);
          const RefreshReport:any = ref(null);
          const Report:any = ref(null);
          const Profil:any = ref(null);
           

            changeRoute("home");  



            const selectedTab = ref<string>("")

            const logoutEvent = LogoutStateServiceForRoot.getLogoutStateService()
            const benutzerName = ref<string>(UserProfile.GetUserProfile().userDisplayName);
            const isRefreshVisible = ref<boolean>(false)
            const disabled = ref<boolean>(false)

            const isPasswordEditVisible = ref<boolean>(false)
            const kennwortData = reactive({
                idPerson: UserProfile.GetUserProfile().personId,
                isVisible: false,
                className: "dialog__wrapper",
                refresh: new Date(),
                mode: "change",
                hasPassword: true,
                isUser: true,
                isAdminMode: false
            })

            function onPasswordChanged(hasChanged: boolean) {
                isPasswordEditVisible.value = !isPasswordEditVisible.value
                if ( hasChanged) {
                    kennwortData.hasPassword = true
                    kennwortData.mode = "change"
                }
                return
            }


            const rowMenuReceiver = StammdatenReceiverServiceForRoot.getMenuCommandService()
            const rowMenuReceiverSubscription = rowMenuReceiver.subscription().subscribe({
                next: (value) => {
                    if ( value.receiver && (value.receiver === "berichtSuche" || value.receiver === "berichtAuswertung")) {
                      return
                    }

                    if (value.command === "Edit" || value.command === "New") {
                      const element = document.getElementById('idMainNavbar')
                      if( element) element.classList.add('disable-div');
                      disabled.value = true
                    }   
                    if(value.command === "Save" || value.command === "Cancel") {
                      const element = document.getElementById('idMainNavbar')
                      if( element) element.classList.remove('disable-div');
                       disabled.value = false
                    }
                }
            })				
			


              //const gridEventService = GridEventService.getGridEventService()

              function getRandomInt(max: number) {
                return Math.floor(Math.random() * max);
              }

            function resetTabStyle() {
              if(Home && Home.value) Home.value.className = "nav-link menu__text"
              if(Dokument && Dokument.value) Dokument.value.className = "nav-link menu__text"
              if(Auftrag && Auftrag.value) Auftrag.value.className = "nav-link menu__text"
              if(Bericht && Bericht.value) Bericht.value.className = "nav-link menu__text"
              if(ControlCenter && ControlCenter.value) ControlCenter.value.className = "nav-link menu__text"
              if(Stammdaten && Stammdaten.value) Stammdaten.value.className = "nav-link menu__text"
              if(Benutzerdaten && Benutzerdaten.value) Benutzerdaten.value.className = "nav-link menu__text"
              if(RefreshReport && RefreshReport.value) RefreshReport.value.className = "nav-link menu__text"
              if(Report && Report.value) Report.value.className = "nav-link menu__text"
              if(Profil && Profil.value) Profil.value.className = "nav-link menu__text"
             

            }

            function action( actionName: string ) : void { 
                resetTabStyle()

                isRefreshVisible.value = false
                if (actionName === "Home" ) {
                  selectedTab.value = "Home"
                  Home.value.className = "nav-link active menu__text";    
                  changeRoute("home");
                }
                if (actionName === "Stammdaten" ) {
                  selectedTab.value = "Stammdaten"
                  Stammdaten.value.className = "nav-link active menu__text";
                  isRefreshVisible.value = true
                  changeRoute("stammdaten"); 
                }
                if (actionName === "Benutzerdaten" ) {
                  selectedTab.value = "Benutzerdaten"
                  Benutzerdaten.value.className = "nav-link active menu__text";
                  isRefreshVisible.value = true
                  changeRoute("benutzerdaten"); 
                }

                if (actionName === "Report") {
                  selectedTab.value = "Report"
                  Report.value.className = "nav-link active menu__text";
                  changeRoute("CreateCustomerDocuments");
                }
                if (actionName === "RefreshReport") {
                  selectedTab.value = "RefreshReport"
                  RefreshReport.value.className = "nav-link active menu__text";
                  changeRoute("ShowDeviceData");
                }
                
                
                if (actionName === "AuftragsErfassung") {
                  selectedTab.value = "Auftrag"
                  Auftrag.value.className = "nav-link active menu__text";
                  changeRoute("auftrag"); 
                }
                if (actionName === "DocumentManagement") {
                  selectedTab.value = "Dokument"
                  Dokument.value.className = "nav-link active menu__text";
                    changeRoute("DocumentManagement");
                }

                if (actionName === "ControlCenter") {
                  selectedTab.value = "ControlCenter" 
                  ControlCenter.value.className = "nav-link active menu__text";
                  changeRoute("ControlCenter");   
                }    
                if (actionName === "Berichte" ) {
                  selectedTab.value = "Bericht"
                  Bericht.value.className = "nav-link active menu__text";
                  changeRoute("berichte");
                }

                if (actionName === "Logout" ) {                  
                  logoutEvent.changeLogoutState({isLogout: true})
                  logoutEvent.changeLogoutState({isLogout: false})
                }

                if( actionName === "ChangePassword") { 
                  selectedTab.value = "Profile"
                  Profil.value.className = "nav-link active menu__text";                
                  kennwortData.isVisible = true
                  isPasswordEditVisible.value = !isPasswordEditVisible.value
                }
            }

            function isReportAllowed() : boolean {
                return true;
            }

            function IsInFunctionalRoles(functionalRoleName: string) : boolean {
              return UserProfile.IsInFunctionalRoles(functionalRoleName)
            }

            async function changeRoute(routeName: string) {
              const failure = await router.push({ name: routeName});

              if (isNavigationFailure(failure, NavigationFailureType.aborted)) {
                console.error('')
              }
              if (isNavigationFailure(failure, NavigationFailureType.cancelled)) {
                console.log(failure.to.path)
                console.log(failure.from.path)
              }
              if (isNavigationFailure(failure, NavigationFailureType.duplicated)) {
                console.log(failure.to.path)
                console.log(failure.from.path)
              }

              if (router.currentRoute.value.redirectedFrom) {
                console.log("Redirect")
              }

            }

          function onSelect(action: string) {
            const refreshGridState = RefreshGridServiceForRoot.getRefreshGridService()
            refreshGridState.changeRefresh("mandantBereichSuche",true, true)
            refreshGridState.reset()
          }

          onUnmounted(() => {
            rowMenuReceiverSubscription.unsubscribe()
          })

            return {
                action,
                isReportAllowed,
                benutzerName,
                logoutIcon,
                uploadIcon,
                arrowRotateCcwIcon,
                isRefreshVisible,
                IsInFunctionalRoles,
                onSelect,
                disabled,
                isPasswordEditVisible,
                kennwortData,
                onPasswordChanged,
                Home,
                Dokument,
                Auftrag,
                Bericht,
                ControlCenter,
                Stammdaten,
                Benutzerdaten,
                RefreshReport,
                Report,
                Profil
                
            
            }
          }          
    })
</script>
<style  lang="scss"> 


  .menu__text {
    font-size: 1rem!important;
    font-weight: bold;
    color: black!important;
   
  }

  .icon__button-icon {
    // background-color: lightgrey;
  }


  .icon__button-icon:hover { 
      background-color: lightgrey;
      cursor: pointer;
  }

  .nav-item:hover {
    background-color: rgb(180,180,180);
    cursor: pointer;
  }


  .active {
    background-color: rgba(90, 90, 90, 0.5)!important
  }

  .disable-div * {
    pointer-events: none;
    opacity: 0.8;
}
</style>